import { z } from "zod";

export const articleResolutionSchema = z.object({
  resolution: z.enum(["refund", "exchange", "exchange-credit", "discount"] as const),
});

export type ArticleResolutionFormValues = z.infer<typeof articleResolutionSchema>;
